export const AnyProjectId: number = 0;
